import React, { useMemo, useRef, useState } from 'react'
import { H4, H6, S1 } from '../../../../../../../../../../Styles/typography'
import Button from '../../../../../../../../../../Components/Buttons/Button'
import { OverviewEl, RegistrationEl } from '../elements'
import { motion } from 'framer-motion'
import { slowSpring } from '../../../config/animation'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../../Store/CourseStore'
import { Link, withRouter } from 'react-router-dom'
import date from 'date-and-time'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import useTime from '../../../../../../../../../../Helpers/CustomHooks/useTime'
import RecordedCourseDashboardStore from '../../../../../stores/RecordedCourseDashboardStore'
import { AccessTime, ForumOutlined, WhatsApp } from '@material-ui/icons'
import ToolTip from '../elements/Tooltip'
import useSWR from 'swr'
import { slsCoreBaseUrl } from '../../../../../..../../../../../../../API/config'
import { accent } from '../../../../../../../../../../Styles/colors'
import { useToggle } from '../../../../../../../../../../Helpers/CustomHooks/useToggle'
const Overview = ({
  history,
  location,
  match: {
    params: { courseURL, livDemyID },
  },
}) => {
  const now = useTime(5000)
  const player = useRef(false)
  const [showCover, toggleCover] = useState(true)
  const {
    activeSubscription = [],
    toggleRegistrationModal,
  } = RecordedCourseDashboardStore.useContainer()
  const { data } = useSWR(`${slsCoreBaseUrl}/user/notification/settings`)
  const whatsappNumber = useMemo(() => {
    console.log('data', data)
    return !Boolean(data?.whatsappNumber)
  }, [data])
  const [disabled, toggle] = useToggle(false)

  return (
    <Subscribe to={[CourseStore]}>
      {({
        state: {
          startTime = 0,
          chapters,
          discount = 0,
          stdFee,
          userType,
          enrollments = [],
          allEnrollments = [],
          coverVideoUrl,
          cover,
          hasCertification = false,
        },
        enrollRecorded,
      }) => {
        const lessonCount = chapters.reduce(
          (sum, chapter) => sum + (chapter.lessons || []).length,
          0,
        )
        const pendingRecordedEnrollment =
          enrollments[0]?.status === 'REGISTERED' &&
          enrollments[0]?.billStatus !== 'PAID'

        const enrolledInRecorded = enrollments[0]?.billStatus === 'PAID'

        const nextChapterLink = `/${livDemyID}/course/${courseURL}/chapter/${chapters[0].id}/lesson/${chapters[0].lessons[0].id}`

        const paidEnrollments = allEnrollments.filter((enrollment) => {
          return enrollment.billStatus === 'PAID'
        })
        const sortedPaidEnrollments = paidEnrollments.sort((a, b) => {
          return new Date(b.paidAt) - new Date(a.paidAt)
        })
        const lastPaidEnrollment = sortedPaidEnrollments[0]

        const lastEnrollment = allEnrollments?.[0]

        const needUpgrade =
          (lastPaidEnrollment?.billStatus === 'PAID' &&
            !(
              lastPaidEnrollment?.paidAt > Date.now() - 1000 * 60 * 60 * 1 ||
              (lastPaidEnrollment?.sessionCount || 0) < 2
            )) ||
          !lastPaidEnrollment?.registrationType ||
          lastPaidEnrollment?.registrationType === 'STANDARD' ||
          (lastEnrollment?.registrationType === 'UPGRADE' &&
            lastEnrollment?.billStatus !== 'PAID')
        const PendingUpgrade =
          lastEnrollment?.billStatus !== 'PAID' &&
          lastEnrollment?.registrationType === 'UPGRADE'

        const subscriptionDiscount = (() =>
          activeSubscription[0]?.discounts?.recordedCourse || 0)()

        const finalDiscount = (() => {
          return discount + ((100 - discount) * subscriptionDiscount) / 100
        })()
        console.log(
          'lastEnrollment,lastPaidEnrollment,needUpgrade,PendingUpgrade',
          lastEnrollment,
          lastPaidEnrollment,
          needUpgrade,
          PendingUpgrade,
        )
        return (
          <OverviewEl
            layout
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className='video'>
              <div className='vid-container'>
                <motion.video
                  onContextMenu={(e) => e.preventDefault()}
                  ref={player}
                  layoutId='coverVideo'
                  transition={slowSpring}
                  src={coverVideoUrl}
                  controls
                  controlsList='nodownload'
                />
                {showCover && (
                  <motion.div
                    className='cover'
                    style={{
                      background: `url(${cover}) center center /cover no-repeat`,
                    }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    {Boolean(coverVideoUrl) && (
                      <div
                        className='playIcon'
                        onClick={() => {
                          toggleCover(false)

                          player.current.play()
                        }}
                      >
                        <PlayCircleOutlineIcon />
                      </div>
                    )}
                  </motion.div>
                )}
              </div>
            </div>
            <div className='right'>
              <ul className='highlights'>
                {now < startTime && (
                  <li>
                    <span className='unlock' />
                    <H6>
                      Available from{' '}
                      {date.format(new Date(startTime), `DD MMM YYYY`)}
                    </H6>
                  </li>
                )}

                <li>
                  {/* <span className='play' /> */}
                  <PlayCircleOutlineIcon
                    style={{
                      marginRight: '0.6em',
                      height: '0.7em',
                      width: '0.7em',
                      minHeight: '0.7em',
                    }}
                  />
                  <H6>{lessonCount} video lessons with included resources</H6>
                </li>
                <li>
                  {/* <span className='speed' /> */}
                  <AccessTime
                    style={{
                      marginRight: '0.6em',
                      height: '0.7em',
                      width: '0.7em',
                      minHeight: '0.7em',
                    }}
                  />
                  <H6>Self Paced Course</H6>
                </li>
                <li>
                  {/* <span className='forum' /> */}
                  <ForumOutlined
                    style={{
                      marginRight: '0.6em',
                      height: '0.7em',
                      width: '0.7em',
                      minHeight: '0.7em',
                    }}
                  />
                  <H6>Global discussion forum support</H6>
                </li>
                {whatsappNumber ? (
                  <li>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Link to={'/dashboard/settings'}>
                        <WhatsApp
                          style={{
                            marginRight: '0.6em',
                            height: '0.7em',
                            width: '0.7em',
                            minHeight: '0.7em',
                          }}
                        />
                      </Link>
                      <H6>
                        <Link
                          to={'/dashboard/settings'}
                          style={{ color: accent }}
                        >
                          Class reminders via WhatsApp
                        </Link>
                        <ToolTip
                          toolTip={`Class reminders and updates are notified via WhatsApp. Connect your WhatsApp now!`}
                          position='top'
                          iconStyle={{
                            height: '15px',
                            width: '15px',
                            top: '-7px',
                            position: 'relative',
                          }}
                        />
                      </H6>
                    </div>
                  </li>
                ) : (
                  <li>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <WhatsApp
                        style={{
                          marginRight: '0.6em',
                          height: '0.7em',
                          width: '0.7em',
                          minHeight: '0.7em',
                        }}
                      />
                      <H6>
                        Class reminders via WhatsApp
                        <ToolTip
                          toolTip={`Class reminders and updates are notified via WhatsApp. Connect your WhatsApp now!`}
                          position='top'
                          iconStyle={{
                            height: '15px',
                            width: '15px',
                            top: '-7px',
                            position: 'relative',
                          }}
                        />
                      </H6>
                    </div>
                  </li>
                )}
              </ul>

              <RegistrationEl
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                expanded={true}
              >
                <div className='fee'>
                  {!(enrolledInRecorded || userType === 'teacher') && (
                    <>
                      {Boolean(finalDiscount) && (
                        <S1 className='original'>
                          <span className='percentOff'>
                            ({finalDiscount}% off)
                          </span>
                          <span className='originalAmount'>
                            {stdFee?.currency} {stdFee?.amount}
                          </span>
                        </S1>
                      )}
                      <div className='final'>
                        {Boolean(finalDiscount) ? (
                          <H4 bold>
                            {stdFee?.currency}{' '}
                            {Math.round(
                              stdFee.amount * (1 - finalDiscount / 100) * 100,
                            ) / 100}
                          </H4>
                        ) : (
                          <H4 bold>
                            {stdFee?.currency} {stdFee?.amount}
                          </H4>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className='actions'>
                  {(enrolledInRecorded || userType === 'teacher') &&
                  now > startTime ? (
                    <Link to={nextChapterLink}>
                      <Button
                        onClick={() => {}}
                        name='Start Watching'
                        type='primary'
                      />
                    </Link>
                  ) : (
                    <Button
                      onClick={async () => {
                        if (userType === 'anonymous') {
                          history.push({
                            pathname: '/auth/login',
                            state: { from: location },
                          })
                        } else if (pendingRecordedEnrollment) {
                          history.push(
                            `/billing/payment/${enrollments[0]?.billId}`,
                          )
                        } else {
                          toggleRegistrationModal(true)
                        }
                      }}
                      type='primary'
                      name={
                        enrolledInRecorded
                          ? 'Registered'
                          : pendingRecordedEnrollment
                          ? 'Complete Registration'
                          : 'Register'
                      }
                      disabled={enrolledInRecorded || userType === 'teacher'}
                      requiresLogin
                    />
                  )}
                  {needUpgrade && enrolledInRecorded && hasCertification ? (
                    <Button
                      onClick={async () => {
                        if (userType === 'anonymous') {
                          history.push({
                            pathname: '/auth/login',
                            state: { from: location },
                          })
                        } else if (PendingUpgrade) {
                          history.push(
                            `/billing/payment/${lastEnrollment?.billId}`,
                          )
                        } else {
                          toggle(true)
                          const success = await enrollRecorded('UPGRADE')
                          if (success) {
                            history.push(`/billing/payment/${success.billId}`)
                          }
                          toggle(false)
                        }
                      }}
                      style={{ marginLeft: '1em' }}
                      type='primary'
                      name={PendingUpgrade ? 'Complete Upgrade' : 'Upgrade'}
                      disabled={
                        !needUpgrade || userType === 'teacher' || disabled
                      }
                      requiresLogin
                    />
                  ) : (
                    <></>
                  )}
                  {userType === 'teacher' && (
                    <Link
                      to={`/${livDemyID}/course/${courseURL}/review-submissions`}
                    >
                      <Button
                        onClick={() => {}}
                        name='Review Submissions'
                        type='primary'
                      />
                    </Link>
                  )}
                </div>
              </RegistrationEl>
            </div>
          </OverviewEl>
        )
      }}
    </Subscribe>
  )
}

export default withRouter(Overview)
